import type { MaybeRefOrGetter } from 'vue'
import type { LandingTemplateButtonsMap } from './landingTemplateButtons'
import type { TemplateData } from './templates-interface'
import { computed, toValue } from 'vue'
import { normalizeLandingTemplateButtons } from './landingTemplateButtons'

export function useTemplateViewButtons(templateData: MaybeRefOrGetter<TemplateData | null | undefined>) {
  return computed<LandingTemplateButtonsMap>(() => {
    const source = toValue(templateData)
    if (!source || !('buttons' in source)) {
      return normalizeLandingTemplateButtons()
    }

    return normalizeLandingTemplateButtons(source.buttons)
  })
}
